import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { RefreshCw } from 'lucide-react';
import type { FilterState } from '../GlobalFilters';

interface ReturnsQualityTabProps {
  clientId: string;
  filters: FilterState;
}

export function ReturnsQualityTab({ clientId, filters }: ReturnsQualityTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <RefreshCw className="mr-2 h-5 w-5" />
          Retours & Qualité
        </CardTitle>
        <CardDescription>Analyse des retours et de la satisfaction client</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Données des retours en cours de chargement...</p>
      </CardContent>
    </Card>
  );
}